import type { ChangeEvent } from 'react';
import { useTranslation } from 'react-i18next';

interface SignupNameFieldProps {
  value: string;
  error?: string;
  onChange: (value: string) => void;
  onBlur: () => void;
  disabled?: boolean;
}

export const SignupNameField = ({
  value,
  error,
  onChange,
  onBlur,
  disabled,
}: SignupNameFieldProps) => {
  const { t } = useTranslation('auth');
  const handleChange = (e: ChangeEvent<HTMLInputElement>) => onChange(e.target.value);

  return (
    <div className="signup-page__field">
      <label className="login-page__label" htmlFor="signupName">
        {t('signup.fields.name')}
      </label>
      <div className="login-page__input-wrap">
        <input
          id="signupName"
          type="text"
          className={`login-page__input signup-page__input-no-icon${
            error ? ' login-page__input--error' : ''
          }`}
          placeholder={t('signup.placeholders.name')}
          maxLength={50}
          value={value}
          onChange={handleChange}
          onBlur={onBlur}
          disabled={disabled}
          aria-invalid={!!error}
          aria-describedby={error ? 'signupNameError' : undefined}
        />
      </div>
      {error && (
        <p id="signupNameError" className="login-page__error" role="alert">
          {error}
        </p>
      )}
    </div>
  );
};
